/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react'

import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import Loading from 'Components/loading'

interface ISeriesItem {
  series_id: number
  series_name: string
  sub_brand_name: string
}
interface ISeries {
  type: string
  info: ISeriesItem
}
interface IProp {
  show?: boolean
  style?: React.CSSProperties
  brandId?: number
  onChange: (id: number, name: string) => void
}

const Series = ({ brandId, onChange, show = false, style = {} }: IProp) => {
  const [series, setSeries] = useState<ISeries[]>([])
  const [loading, setLoading] = useState(false)
  const [empty, setEmpty] = useState(false)
  useEffect(() => {
    fetchSeries()
  }, [brandId])
  // 获取品牌数据
  function fetchSeries() {
    if (!brandId) return
    setLoading(true)
    fetch(
      getUrl(
        `/motor/brand/v4/brand_series_list/?no_sales=3&show_historical_series=0&with_offline_series_list=0&brand_id=${brandId}`
      )
    )
      .then((res) => {
        setLoading(false)
        // 找不到车系
        if (!res.data || res.data.length === 0) {
          setEmpty(true)
          setSeries([])
          return
        }
        if (res.status === 0) {
          setSeries(res.data)
          setEmpty(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  if (!show || !brandId) return null
  return (
    <section className="series-selector g-hover-scroll-bar" style={style}>
      {loading && <Loading />}
      {empty && <div className="empty">暂无车系</div>}
      {series.map((item: ISeries) => {
        if (item.type !== '1003') {
          return (
            <p
              key={item.info.series_id}
              onClick={(e) => {
                e.stopPropagation()
                onChange(item.info.series_id, item.info.series_name)
              }}
            >
              {item.info.series_name}
            </p>
          )
        }
      })}
      <style jsx>
        {`
          section {
            position: fixed;
            top: 120%;
            right: 0;
            width: 260px;
            max-height: 432px;
            background-color: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            overflow: auto;
            transform: translateZ(0);
            -webkit-overscroll-behavior: none;
          }
          h4 {
            position: sticky;
            top: 0;
            height: 28px;
            padding-left: 16px;
            line-height: 28px;
            font-size: 14px;
            border-bottom: 1px solid #e6e8f2;
            background: #fff;
          }
          p {
            padding-left: 16px;
            line-height: 40px;
            height: 40px;
            font-size: 14px;
            border-bottom: 1px solid #e6e8f2;
            @apply tw-text-common-black tw-cursor-pointer;
          }
          p:hover {
            background: rgb(255, 204, 50, 0.2);
          }
          .empty {
            padding: 10px 0;
            text-align: center;
            color: #999;
          }
        `}
      </style>
    </section>
  )
}

export default Series
